import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { screenSizes } from '../Literals';
import { adminTableStyles, AdminTableContent } from './AdminTable';

const resultPresentationStyles = css`
  .results-meta {
    margin-bottom: 1.5rem;
    padding: 1rem 1.15rem;
    background: #f3f9fc;
    border: 1px solid #d8ecf5;
    border-radius: 14px;

    &__name {
      margin: 0 0 0.55rem;
      font-size: clamp(1rem, 2.8vw, 1.2rem);
      line-height: 1.35;
      color: #1a1a1a;
    }

    &__row {
      display: flex;
      flex-wrap: wrap;
      gap: 0.35rem 1rem;
      font-size: 0.9rem;
      color: #5f6b76;
    }

    &__org {
      font-style: italic;
    }
  }

  .result-section {
    margin-top: 1.5rem;
    padding: 1.15rem 1.15rem 1.25rem;
    background: #fff;
    border: 1px solid #e6eef3;
    border-radius: 14px;
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    min-width: 0;

    &__header {
      margin-bottom: 1rem;

      h2 {
        margin: 0 !important;
        padding: 0 !important;
        text-align: left !important;
        font-size: clamp(1.15rem, 3.2vw, 1.45rem);
        font-weight: 700;
        line-height: 1.3;
        color: #1a1a1a;
        overflow-wrap: anywhere;
        word-break: break-word;
      }
    }

    &__eyebrow {
      margin: 0 0 0.35rem;
      padding: 0;
      font-size: 0.7rem;
      font-weight: 700;
      letter-spacing: 0.07em;
      text-transform: uppercase;
      color: #2b8fbc;
      text-align: left;
    }
  }

  .disc-letter {
    display: flex;
    align-items: center;
    gap: 0.85rem;
    margin-bottom: 1rem;
    padding: 0.85rem 1rem;
    background: #f3f9fc;
    border: 1px solid #d8ecf5;
    border-radius: 12px;

    &__char {
      flex-shrink: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 3.25rem;
      height: 3.25rem;
      border-radius: 12px;
      background: #1a1a1a;
      color: #fff;
      font-size: 1.55rem;
      font-weight: 700;
      line-height: 1;
    }

    &__label {
      font-size: clamp(1rem, 3vw, 1.25rem);
      font-weight: 700;
      color: #1a1a1a;
      line-height: 1.3;
    }
  }

  .disc-combo {
    margin-top: 1.25rem;
    padding-top: 1.15rem;
    border-top: 1px solid #e6eef3;

    &__badge {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      margin-bottom: 0.9rem;
      padding: 0.85rem 1rem;
      background: #f8fafc;
      border: 1px solid #e6eef3;
      border-radius: 12px;
    }

    &__letters {
      font-size: clamp(1.15rem, 3.5vw, 1.5rem);
      font-weight: 700;
      color: #1a1a1a;
      letter-spacing: 0.02em;
    }

    &__names {
      font-size: 0.92rem;
      font-weight: 600;
      color: #5f6b76;
      line-height: 1.35;
    }
  }

  .result-item {
    margin-top: 1rem;
    padding: 1rem;
    background: #fafcfd;
    border: 1px solid #e6eef3;
    border-radius: 12px;

    &__header {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: space-between;
      gap: 0.5rem 0.75rem;
      margin-bottom: 0.75rem;
    }

    &__title {
      margin: 0 !important;
      padding: 0;
      text-align: left;
      font-size: clamp(1.05rem, 3vw, 1.25rem);
      font-weight: 700;
      line-height: 1.3;
      color: #1a1a1a;
      flex: 1 1 12rem;
    }

    &__score {
      display: inline-flex;
      align-items: center;
      padding: 0.35rem 0.7rem;
      border-radius: 999px;
      background: #e8f6fc;
      border: 1px solid #c5e8f5;
      font-size: 0.8rem;
      color: #2b8fbc;
      white-space: nowrap;

      strong {
        margin-left: 0.25rem;
        color: #1a1a1a;
      }
    }

    &__body {
      color: #3d4a55;
      font-size: 0.95rem;
      line-height: 1.55;
      overflow-wrap: anywhere;
      word-break: break-word;

      p {
        margin: 0 0 0.65rem;
        padding: 0;
        line-height: 1.55;

        &:last-child {
          margin-bottom: 0;
        }
      }

      strong,
      b {
        display: inline;
        margin: 0;
        color: #1a1a1a;
        font-weight: 700;
      }

      > strong {
        display: block;
        margin: 0.85rem 0 0.45rem;
        font-size: 0.82rem;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: #2b8fbc;
      }
    }
  }

  /* Legacy class names — do not zero horizontal padding on result cards */
  .DISC,
  .spiritual,
  .connecting,
  .additional-info {
    border-top: none;
  }

  .result-section.DISC,
  .result-section.spiritual,
  .result-section.connecting,
  .result-section.additional-info {
    padding: 1.15rem 1.15rem 1.25rem;
  }

  .DISC h2,
  .spiritual h2,
  .connecting h2,
  .additional-info h2 {
    margin: 0;
  }

  .DISC h3 {
    margin: 0;
    font-size: inherit;
  }
`;

export const crecerClase3ResultsStyles = css`
  .crecerp1c3 {
    input {
      width: 100%;
    }
  }
  .results {
    padding: 20px 40px;
    h1 {
      text-align: center;
    }
    .info {
      width: 45%;
      display: inline-block;
      padding: 20px 00 0 0;
      vertical-align: top;
      p {
        margin: 5px 0;
        &.userdata {
          font-size: 25px;
          padding: 10px;
        }
      }
    }
    .content {
      padding: 50px 30px;
    }
    .parents {
      padding: 0 0 0 20px;
    }
    #tutorForm {
      margin: 20px 0 0 0;
      display: inline-block;
      background-color: whitesmoke;
      width: 45%;
      padding: 20px;
      text-align: center;
      textarea {
        display: block;
        width: 80%;
      }
      .ui.checkbox {
        margin: 30px 0 20px 0;
      }
    }
    ${resultPresentationStyles}
    .additional-info {
      margin-top: 30px;
      h3 {
        margin: 15px 0 10px 0;
        font-size: 18px;
        color: #333;
      }
      p {
        margin: 5px 0;
        &.question-text {
          font-weight: bold;
          margin-bottom: 8px;
        }
        &.answer-text {
          margin-left: 20px;
          color: #666;
          font-style: italic;
        }
      }
      .question-answer {
        margin-bottom: 15px;
        padding: 10px 0;
      }
    }
  }

  @media only screen and (max-width: ${screenSizes.laptop}) {
    .results {
      padding: 0.75rem;
      .info {
        width: 100%;
        p.userdata {
          font-size: 1.05rem;
          padding: 0.35rem 0;
        }
      }
      #tutorForm {
        width: 100%;
        box-sizing: border-box;
      }
      .content {
        padding: 0.5rem 0;
      }
    }
  }

  @media only screen and (max-width: ${screenSizes.tablet}) {
    .results {
      padding: 0.5rem;

      .disc-letter {
        gap: 0.7rem;
        padding: 0.75rem 0.85rem;

        &__char {
          width: 2.85rem;
          height: 2.85rem;
          font-size: 1.35rem;
        }
      }

      .result-section {
        padding: 1rem 0.85rem;
        border-radius: 12px;
      }

      .result-item {
        padding: 0.85rem;
      }

      .result-item__body {
        font-size: 0.92rem;
      }
    }
  }

  @media only screen and (max-width: ${screenSizes.mobile}) {
    .results {
      padding: 0.25rem 0;

      .results-meta {
        padding: 0.85rem 0.9rem;
        border-radius: 12px;
      }

      .disc-letter {
        flex-direction: row;
        align-items: center;

        &__char {
          width: 2.6rem;
          height: 2.6rem;
          font-size: 1.25rem;
          border-radius: 10px;
        }

        &__label {
          font-size: 1rem;
        }
      }

      .disc-combo__names {
        font-size: 0.85rem;
      }

      .result-item__header {
        flex-direction: column;
        align-items: flex-start;
      }
    }
  }
`;

export const CrecerClase3AdminTable = styled.section`
  ${adminTableStyles}
  ${crecerClase3ResultsStyles}

  /* Public survey results must not inherit admin table viewport min-widths */
  &.survey-results-view {
    min-width: 0 !important;
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    box-sizing: border-box;
  }
`;

export const CrecerResultsContainer = styled.div`
  padding: 20px 40px;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  overflow-wrap: anywhere;
  word-break: break-word;

  h1 {
    text-align: center;
  }
  .info {
    width: 45%;
    display: inline-block;
    padding: 20px 00 0 0;
    vertical-align: top;
    p {
      margin: 5px 0;
      &.userdata {
        font-size: 25px;
        padding: 10px;
      }
    }
  }
  .content {
    padding: 50px 30px;
  }
  .parents {
    padding: 0 0 0 20px;
  }
  #tutorForm {
    margin: 20px 0 0 0;
    display: inline-block;
    background-color: whitesmoke;
    width: 45%;
    padding: 20px;
    text-align: center;
    textarea {
      display: block;
      width: 80%;
    }
    .ui.checkbox {
      margin: 30px 0 20px 0;
    }
  }

  ${resultPresentationStyles}

  .additional-info {
    margin-top: 30px;
    h3 {
      margin: 15px 0 10px 0;
      font-size: 18px;
      color: #333;
    }
    p {
      margin: 5px 0;
      &.question-text {
        font-weight: bold;
        margin-bottom: 8px;
      }
      &.answer-text {
        margin-left: 20px;
        color: #666;
        font-style: italic;
      }
    }
    .question-answer {
      margin-bottom: 15px;
      padding: 10px 0;
    }
  }

  @media only screen and (max-width: ${screenSizes.laptop}) {
    padding: 0.75rem 1rem;

    .info {
      width: 100%;

      p.userdata {
        font-size: 1.05rem;
        padding: 0.35rem 0;
      }
    }
    #tutorForm {
      width: 100%;
      box-sizing: border-box;
    }
    .content {
      padding: 0.5rem 0;
    }
  }

  @media only screen and (max-width: ${screenSizes.tablet}) {
    padding: 0.5rem 0.75rem;

    .disc-letter {
      gap: 0.7rem;
      padding: 0.75rem 0.85rem;

      &__char {
        width: 2.85rem;
        height: 2.85rem;
        font-size: 1.35rem;
      }
    }

    .result-section,
    .result-section.DISC,
    .result-section.spiritual,
    .result-section.connecting,
    .result-section.additional-info {
      padding: 1rem 1rem 1.1rem;
      border-radius: 12px;
    }

    .result-item {
      padding: 0.9rem;
    }

    .result-item__body {
      font-size: 0.92rem;
    }
  }

  @media only screen and (max-width: ${screenSizes.mobile}) {
    padding: 0.35rem 0.5rem;

    .results-meta {
      padding: 0.85rem 0.95rem;
      border-radius: 12px;
    }

    .disc-letter__char {
      width: 2.6rem;
      height: 2.6rem;
      font-size: 1.25rem;
      border-radius: 10px;
    }

    .disc-letter__label {
      font-size: 1rem;
    }

    .disc-combo__names {
      font-size: 0.85rem;
    }

    .result-item__header {
      flex-direction: column;
      align-items: flex-start;
    }

    .result-section,
    .result-section.DISC,
    .result-section.spiritual,
    .result-section.connecting,
    .result-section.additional-info {
      padding: 0.95rem 0.95rem 1.05rem;
      margin-top: 1rem;
    }

    .result-item {
      padding: 0.85rem 0.9rem;
    }
  }

  &.survey-results-body {
    min-width: 0;
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    overflow-wrap: anywhere;
    word-break: break-word;

    .results-meta {
      margin-bottom: 1.15rem;
      padding: 1rem 1.1rem;
    }

    .result-section,
    .result-section.DISC,
    .result-section.spiritual,
    .result-section.connecting,
    .result-section.additional-info,
    .result-item,
    .result-item__body,
    .disc-primary,
    .disc-combo {
      min-width: 0;
      max-width: 100%;
      box-sizing: border-box;
    }

    .result-section,
    .result-section.DISC,
    .result-section.spiritual,
    .result-section.connecting,
    .result-section.additional-info {
      padding: 1.15rem 1.15rem 1.25rem;
    }

    .result-item__body {
      white-space: normal;
    }

    @media only screen and (max-width: ${screenSizes.tablet}) {
      .results-meta {
        padding: 0.9rem 1rem;
      }

      .result-section,
      .result-section.DISC,
      .result-section.spiritual,
      .result-section.connecting,
      .result-section.additional-info {
        padding: 1rem 1rem 1.1rem;
      }
    }

    @media only screen and (max-width: ${screenSizes.mobile}) {
      .results-meta {
        padding: 0.85rem 0.95rem;
      }

      .result-section,
      .result-section.DISC,
      .result-section.spiritual,
      .result-section.connecting,
      .result-section.additional-info {
        padding: 0.95rem 0.95rem 1.05rem;
      }

      .result-item {
        padding: 0.85rem 0.9rem;
      }
    }
  }
`;

export const CrecerAdminTableContent = styled(AdminTableContent)`
  .crecerp1c3 input {
    width: 100%;
  }
`;
